import { render } from "./TextBetweenLines.vue?vue&type=template&id=8046e850&scoped=true&ts=true"
import script from "./TextBetweenLines.vue?vue&type=script&lang=ts"
export * from "./TextBetweenLines.vue?vue&type=script&lang=ts"

import "./TextBetweenLines.vue?vue&type=style&index=0&id=8046e850&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8046e850"]])

export default __exports__